import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../features/auth/auth.store';

/** Route guard — everything except /login requires a signed-in admin. */
export function RequireAuth({ children }: PropsWithChildren) {
  const accessToken = useAuthStore((s) => s.tokens?.accessToken);
  if (!accessToken) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
